import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { api } from '../../../auth'
import { fetchKbCategory } from '../api/knowledgeBaseApi'
import type { KbCategoryDetail } from '../types'
import CategoryView from '../components/CategoryView'
import KBSkeleton from '../components/KBSkeleton'

interface CategoryPageProps {
    onBack: () => void
    onSelectArticle: (slug: string) => void
}

const CategoryPage = ({ onBack, onSelectArticle }: CategoryPageProps) => {
    const { slug } = useParams<{ slug: string }>()
    const axiosPrivate = api
    const [data, setData] = useState<KbCategoryDetail | null>(null)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        if (!slug) return
        let cancelled = false
        setLoading(true)
        fetchKbCategory(axiosPrivate, slug)
            .then((res) => {
                if (!cancelled) setData(res)
            })
            .catch(() => {})
            .finally(() => {
                if (!cancelled) setLoading(false)
            })
        return () => {
            cancelled = true
        }
    }, [axiosPrivate, slug])

    if (loading || !data) {
        return (
            <div className="kb-container">
                <KBSkeleton variant="category" />
            </div>
        )
    }

    return (
        <div className="kb-container">
            <CategoryView
                category={data}
                onBack={onBack}
                onSelectArticle={onSelectArticle}
            />
        </div>
    )
}

export default CategoryPage
